document.addEventListener('easysearch_rendered', function (e){
  easysearch.widgetSelectorForCustomSelects = '.easyContainer';

  function initCustomSelects()
  {
    easysearch.jq(easysearch.widgetSelectorForCustomSelects).find('.easysearch-select-holder > select').each(function(i, el){
      var $this = easysearch.jq(this);
      var $holder = $this.parent().closest('.easysearch-holder');
      var num = $holder.children('.easysearch-select-holder').index($this.parent().closest('.easysearch-select-holder')) + 1;

      $this.addClass('select-hidden');
      $this.wrap('<div class="select"></div>');
      $this.after('<div class="select-styled"><span class="select-styled-prefix">' + num + '</span><span class="select-styled-text"></span></div>');
      var $styledSelect = $this.next('div.select-styled');

      var $list = easysearch.jq('<ul />', {
          'class': 'select-options'
      }).insertAfter($styledSelect);

      $styledSelect.click(function(e) {
        e.stopPropagation();
        easysearch.jq('div.select-styled.active').not(this).each(function(){
          easysearch.jq(this).removeClass('active').next('ul.select-options').hide();
        });
        easysearch.jq(this).toggleClass('active').next('ul.select-options').toggle();
      });

      easysearch.jq(document).click(function() {
          $styledSelect.removeClass('active');
          $list.hide();
      });

      document.addEventListener('easysearch_loaded', function (e){
        initCustomSelectsOptions( $this, $styledSelect, $list );
      });

      initCustomSelectsOptions( $this, $styledSelect, $list );
    });
  }

  function initCustomSelectsOptions( $sel, $styledSelect, $list )
  {
    $list.empty();
    $styledSelect.children('.select-styled-text').text( ($sel.children('option:selected').length) ? $sel.children('option:selected').text() : $sel.children('option').eq(0).text() );

    var numberOfOptions = $sel.children('option').length;
    for (var i = 0; i < numberOfOptions; i++) {
        easysearch.jq('<li />', {
            text: $sel.children('option').eq(i).text(),
            rel: $sel.children('option').eq(i).val()
        }).appendTo($list);
    }

    var $listItems = $list.children('li');
    $listItems.click(function(e) {
      e.stopPropagation();
      var $holder = $(this).parent().closest('.easysearch-holder');
      $styledSelect.removeClass('active').children('.select-styled-text').text(easysearch.jq(this).text());
      $list.hide();
      $sel.val(easysearch.jq(this).attr('rel')).trigger('change');

      setTimeout(function(){
        $holder.find('.easysearch-select-holder .select').each(function(){
          var $sel  = easysearch.jq(this).children('select:first');
          var $styledSelect = easysearch.jq(this).children('.select-styled:first');
          var $list = easysearch.jq(this).children('.select-options:first');
          initCustomSelectsOptions( $sel, $styledSelect, $list );
        });
      }, 50);
    });
  }

  initCustomSelects();
});

document.addEventListener('easysearch_loaded', function (){
    let easyClearBtn = document.querySelector('.easysearch-clear-holder a');
       if(easyClearBtn){
         easyClearBtn.textContent = "Reset";
       };
});